import { Box, Button, TextField, Typography } from '@mui/material';
import { apiUrlBase, apiUrlPrefix } from '../../../../config';
import Cookies from 'js-cookie'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';

const Information = ({ selected, error, setError }) => {

  useEffect(() => {
    getAncestry();
  }, []);

  const getAncestry = async () => {
    const userId = localStorage.getItem('userId');
    const response = await fetch(`${apiUrlBase}Ancestry/GetAncestry?userId=${userId}`, {
      method: "GET",
      credentials: "include",
      headers: { 'Content-Type': 'application/json' },
    })
    if(response.ok) {
      const data = await response.json();
      const ancestryInfo = data.userInfo?.ancestry;
      const familyInfo = ancestryInfo?.familyHistory;
      formik.setFieldValue('currentCity', ancestryInfo?.currentCity);
      formik.setFieldValue('hometown', ancestryInfo?.hometown);
      formik.setFieldValue('mother', familyInfo?.mother);
      formik.setFieldValue('father', familyInfo?.father);
      formik.setFieldValue('mGrandmother', familyInfo?.mGrandmother);
      formik.setFieldValue('mGrandfather', familyInfo?.mGrandfather);
      formik.setFieldValue('fGrandmother', familyInfo?.fGrandmother);
      formik.setFieldValue('fGrandfather', familyInfo?.fGrandfather);
      return;
    }
}

  const updateAncestry = async ({ currentCity, hometown, mother, father, mGrandmother, mGrandfather, fGrandmother, fGrandfather }) => {
    const response = await fetch(`${apiUrlBase}Ancestry/UpdatePersonalHistory`, {
      method: "POST",
      credentials: "include",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: localStorage.getItem('userId'),
        CurrentCity: currentCity,
        Hometown: hometown,
        FamilyHistory: {
          Mother: mother,
          Father: father,
          mGrandmother: mGrandmother,
          mGrandfather: mGrandfather,
          fGrandmother: fGrandmother,
          fGrandfather: fGrandfather,
        }
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      setError(errorData);
      throw new Error(errorData.message || "Failed to update ancestry");
    }
    setError("");

    getAncestry();
    return await response.json();
  };

  const formik = useFormik({
    initialValues: {
      currentCity: '',
      hometown: '',
      mother: '',
      father: '',
      mGrandmother: '',
      mGrandfather: '',
      fGrandmother: '',
      fGrandfather: '',
    },
    validationSchema: Yup.object({}), //Doing nothing
    onSubmit: (values) => {
      changePasswordMutation.mutate(values);
    },
  });

  const changePasswordMutation = useMutation({
    mutationFn: updateAncestry,
    onSuccess: (data) => {
      if (data) {
      } else {
        throw new Error('Unexpected response structure');
      }
    },
    onError: (error) => {
      setError(error.message); // Set the error message
    },
  });

  return (
    <Box component="form" className={selected === 0 ? '' : 'hidden'} onSubmit={formik.handleSubmit} sx={{ width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <>
        <Typography variant="h6" sx={{ cursor: 'pointer' }} >Information:</Typography>

        <Typography fontSize={'12px'} sx={{ color: 'red' }}>{error}</Typography>

        <TextField
          label="Current City"
          type="text"
          name="currentCity"
          fullWidth
          value={formik.values.currentCity}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.currentCity && !!formik.errors.currentCity}
          helperText={formik.touched.currentCity && formik.errors.currentCity}
        />

        <TextField
          label="Hometown"
          type="text"
          name="hometown"
          fullWidth
          value={formik.values.hometown}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.hometown && !!formik.errors.hometown}
          helperText={formik.touched.hometown && formik.errors.hometown}
        />
        <Typography>Family History: </Typography>
        <TextField
          label="Mother"
          type="text"
          name="mother"
          fullWidth
          value={formik.values.mother}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.mother && !!formik.errors.mother}
          helperText={formik.touched.mother && formik.errors.mother}
        />
        <TextField
          label="Father"
          type="text"
          name="father"
          fullWidth
          value={formik.values.father}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.father && !!formik.errors.father}
          helperText={formik.touched.father && formik.errors.father}
        />
        <TextField
          label="Mother's side grandmother"
          type="text"
          name="mGrandmother"
          fullWidth
          value={formik.values.mGrandmother}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.mGrandmother && !!formik.errors.mGrandmother}
          helperText={formik.touched.mGrandmother && formik.errors.mGrandmother}
        />

        <TextField
          label="Mother's side grandfather"
          type="text"
          name="mGrandfather"
          fullWidth
          value={formik.values.mGrandfather}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.mGrandfather && !!formik.errors.mGrandfather}
          helperText={formik.touched.mGrandfather && formik.errors.mGrandfather}
        />

        <TextField
          label="Father's side grandmother"
          type="text"
          name="fGrandmother"
          fullWidth
          value={formik.values.fGrandmother}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.fGrandmother && !!formik.errors.fGrandmother}
          helperText={formik.touched.fGrandmother && formik.errors.fGrandmother}
        />

        <TextField
          label="Father's side grandfather"
          type="text"
          name="fGrandfather"
          fullWidth
          value={formik.values.fGrandfather}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.fGrandfather && !!formik.errors.fGrandfather}
          helperText={formik.touched.fGrandfather && formik.errors.fGrandfather}
        />

        <Button
          type="submit"
          variant="contained"
          disabled={changePasswordMutation.isPending}
        >
          {changePasswordMutation.isPending ? 'Processing...' : 'Update Ancestry'}
        </Button>

        <Button color="inherit" >Cancel</Button>
      </>
    </Box>
  )
};

export default Information;